/* eslint-disable max-len */
import { Component, Input } from '@angular/core';
import { DeadlineV2Dto, EventV2Dto } from 'src/app/api/exa';
import { NotificationTypeEnum } from 'src/app/enums/notification-type-enum';
import { EnterpriseCustomerService } from 'src/app/services/enterprise-customer.service';
import { FieldService } from 'src/app/services/field.service';
import { ImplementService } from 'src/app/services/implement.service';
import { MachineService } from 'src/app/services/machine.service';
import { Notification, Priority } from 'src/app/services/notification.service';

@Component({
  selector: 'drawer-content-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent {
  @Input('notifications') notifications: Notification[];
  // TODO use right types here -> maybe construct a suiting one that can hold any type of info we want to show in here

  constructor(
    private machineService: MachineService,
    private implementService: ImplementService,
    private fieldService: FieldService,
    private customerService: EnterpriseCustomerService
  ) {}

  getNotificationIcon(n: Notification) {
    switch (n.type) {
      case NotificationTypeEnum.GENERAL:
        return 'information-circle-outline';
      case NotificationTypeEnum.LICENSE_EXPIRATION:
        return 'warning-outline';
      case NotificationTypeEnum.MACHINES_LONG_OFFLINE:
        return 'alert-circle-outline';
      case NotificationTypeEnum.DEADLINE:
        return 'calendar-outline';
      case NotificationTypeEnum.EVENT:
        return 'location-outline';
    }
  }

  getNotificationColor(n: Notification) {
    switch (n.priority) {
      case Priority.HIGHEST:
      case Priority.HIGH:
        return 'danger';
      default:
        return 'primary';
    }
  }

  // getDeadlineContent(deadline: DeadlineV2Dto): string {
  //   let content = deadline.title;
  //   if (deadline.implement) {
  //     content += ' | ';
  //     content += this.implementService.getFormattedNameById(deadline.implement.id);
  //     content += ' | ';
  //     if (deadline.unit === 'dt') {
  //       content += new Date(deadline.dueInterval + deadline.baseValue).toLocaleDateString().split(',')[0];
  //     } else if (deadline.unit === 'km') {
  //       content += Math.round(deadline.dueInterval - (this.implementService.getImplementById(deadline.implement.id).mileage - deadline.baseValue)) + ' km';
  //     } else if (deadline.unit === 'h') {
  //       content += Math.round(deadline.dueInterval - (this.implementService.getImplementById(deadline.implement.id).operatingHours - deadline.baseValue)) + ' h';
  //     } else if (deadline.unit === 'ha') {
  //       content += Math.round(deadline.dueInterval - (this.implementService.getImplementById(deadline.implement.id).workedArea - deadline.baseValue)) + ' ha';
  //     }
  //   } else if (deadline.machine.id) {
  //     content += ' | ';
  //     content += this.machineService.getFormattedNameById(deadline.machine.id);
  //     content += ' | ';
  //     if (deadline.unit === 'dt') {
  //       content += new Date(deadline.dueInterval + deadline.baseValue).toLocaleDateString().split(',')[0];
  //     } else if (deadline.unit === 'km') {
  //       content += Math.round(deadline.dueInterval - (this.machineService.getMachineById(deadline.machine.id).mileage - deadline.baseValue)) + ' km';
  //     } else if (deadline.unit === 'h') {
  //       content += Math.round(deadline.dueInterval - (this.machineService.getMachineById(deadline.machine.id).operatingHours - deadline.baseValue)) + ' h';
  //     }
  //   }
  //   return content;
  // }

  getEventContent(event: EventV2Dto): string {
    let content = event.type + ': ';
    if (event.type === 'EMPL_E_MACH' || event.type === 'EMPL_L_MACH') {
      content += this.machineService.getFormattedNameById(event.machine.id);
    } else if (event.type === 'EMPL_C_IMPL' || event.type === 'EMPL_UC_IMPL' || event.type === 'L_IMPL' || event.type === 'UL_IMPL') {
      content += this.implementService.getFormattedNameById(event.implement.id);
      // } else if (event.type === 'EMPL_E_FIELD' || event.type === 'EMPL.L_FIELD') {
      //   console.log(event);
      //   content += this.fieldService.getFieldById(event.geometry.field.id);
    } else if (event.type === 'CUSTOMER') {
      content += this.customerService.getCustomerName(event.owner.id);
    } else if (event.data) {
      content += event.data;
    }
    if (event.unit) {
      content += ' ' + event.unit;
    }
    console.log(content);
    return content;
  }
}
